
import { create } from 'zustand'
import { authenticatedAxios, baseURL } from '../../apis'

const useReferrallist = create((set) => ({
  dashboard: {
    total_referral: 0,
    active_referrer: 0,
    total_commission: 0,
    conversion_rate: 0,
    top_referrer: []
  },
  list: [],
  loaded: false,
  actions: {
    getDashboard: async () => {
        try {
            const { data } = await authenticatedAxios.get(`${baseURL}/api/admin/referral/dashboard/`)
            set(() => ({ dashboard: data }))
        } catch (err) {
            console.log(err)
        } finally {
            set(() => ({ loaded: true }))
        }
    },
    getList: async ({ search, active, start_date, end_date, page, size }) => {
        try {
            let url = `${baseURL}/api/admin/referral/list?`
            if(!!search) url += `&search=${search}`
            if(!!active) url += `&active=${active}`
            if(!!start_date) url += `&start_date=${start_date}`
            if(!!end_date) url += `&end_date=${end_date}`
            if(!!page) url += `&page=${page}`
            if(!!size) url += `&size=${size}`
            const { data } = await authenticatedAxios.get(url)
            set(() => ({ list: data }))
        } catch (err) {
            console.log(err)
        } finally {
            set(() => ({ loaded: true }))
        }
    }
  },
}))

export default useReferrallist